<template>
  <!-- vconsole暗门触发区域：连续快速点击页面任意位置5次 -->
  <div id="app" @click="handleVConsoleTrigger">

    <div v-if="!$route.meta.hideTitle">
      <div class="fixed-top fs6 text-center pr7 bc-default" >
          <span id="pageTitle">{{$route.meta.title||''}}</span>
          <div @click="logout" class="logout fs2 pr5 pl5">退出</div>
      </div>
      <div class="place-holder"></div>
    </div>
    <div>
      <keep-alive :include="cachePages">
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import storage from './uitls/cacheUtil';

export default Vue.extend({
  data() {
    return {
      cachePages: [],
      list: [
        'QuotationList',
        'Login',
      ],
      clickCount: 0,
      lastClickTime: null, // 记录上次点击时间戳
      vconsoleLoaded: false,
      vconsoleInstance: null,
    };
  },
  components: {
  },
  computed: {
    // showLogout() {
    //   console.log(storage,this.$route);
    //   return !this.list.includes(this.$route.name);
    // },
  },
  mounted() {
    // 检查localStorage，如果之前已开启vconsole则自动加载
    const vconsoleEnabled = window.localStorage.getItem('vconsole_enabled');
    if (vconsoleEnabled === 'true') {
      this.loadVConsole(true); // 静默加载
    }
  },
  methods: {
    logout() {
      storage.local.set('token', '');
      storage.local.set('type', '');
      this.$router.push('/login');
    },
    // vconsole暗门：连续快速点击右上角5次（每次点击间隔不超过500ms）
    handleVConsoleTrigger() {
      const now = Date.now();
      const maxInterval = 500; // 两次点击最大间隔500ms

      // 如果距离上次点击超过maxInterval，重置计数
      if (this.lastClickTime && now - this.lastClickTime > maxInterval) {
        this.clickCount = 0;
      }

      this.clickCount += 1;
      this.lastClickTime = now;

      // 连续快速点击5次触发
      if (this.clickCount >= 5) {
        this.clickCount = 0;
        this.lastClickTime = null;

        if (this.vconsoleLoaded) {
          this.closeVConsole();
        } else {
          this.loadVConsole();
        }
      }
    },
    // 关闭vconsole
    closeVConsole() {
      if (this.vconsoleInstance) {
        this.vconsoleInstance.destroy();
        this.vconsoleInstance = null;
        this.vconsoleLoaded = false;
        window.localStorage.removeItem('vconsole_enabled');
        // eslint-disable-next-line no-alert
        alert('VConsole已关闭');
      }
    },
    // 动态加载vconsole
    loadVConsole(silent = false) {
      // 如果已有实例，直接返回
      if (this.vconsoleInstance) {
        // eslint-disable-next-line no-alert
        if (!silent) alert('VConsole已开启');
        return;
      }

      // 如果window.VConsole已存在，直接创建实例
      if (window.VConsole) {
        this.vconsoleInstance = new window.VConsole();
        this.vconsoleLoaded = true;
        window.localStorage.setItem('vconsole_enabled', 'true');
        // eslint-disable-next-line no-alert
        if (!silent) alert('VConsole已开启');
        return;
      }

      // 检查script标签是否已存在
      const existingScript = document.querySelector('script[src*="vconsole"]');
      if (existingScript) {
        // script已存在但VConsole未加载，等待加载完成
        existingScript.addEventListener('load', () => {
          if (!this.vconsoleInstance) {
            this.vconsoleInstance = new window.VConsole();
            this.vconsoleLoaded = true;
            window.localStorage.setItem('vconsole_enabled', 'true');
            // eslint-disable-next-line no-alert
            if (!silent) alert('VConsole已开启');
          }
        });
        return;
      }

      // 动态加载script
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js';
      script.onload = () => {
        this.vconsoleInstance = new window.VConsole();
        this.vconsoleLoaded = true;
        window.localStorage.setItem('vconsole_enabled', 'true');
        // eslint-disable-next-line no-alert
        if (!silent) alert('VConsole已开启');
      };
      script.onerror = () => {
        // eslint-disable-next-line no-alert
        if (!silent) alert('VConsole加载失败');
      };
      document.head.appendChild(script);
    },
  },
});
</script>
<style>
#app {
  text-align: center;
  background-color: #f8f8f8;
}
/* vconsole触发区域：右上角不可见区域 */
.vconsole-trigger {
  position: fixed;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
  z-index: 9999;
  background: transparent;
}
.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  line-height: 40px;
  /* border-radius: 50%; */
  /* box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5); */
   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  /* color: #ffffff; */
  /* background-color: #ff976a; */
  z-index: 999;
}
.place-holder {
  height: 40px;
}
.logout {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
;}
</style>
